
  (function(){
    if(window.onlyOniCollectionQuickAddRecoveredV2) return;
    window.onlyOniCollectionQuickAddRecoveredV2 = true;

    var state = { product:null, selectedOptions:[], variant:null, quantity:1, startY:null };

    function money(cents){ return 'Q' + (Number(cents || 0) / 100).toFixed(2); }
    function normalize(value){ return String(value || '').trim(); }

    function isDefaultOnly(product){
      if(!product || !product.options || product.options.length !== 1) return false;
      var option = product.options[0];
      var name = normalize(option.name).toLowerCase();
      var values = option.values || [];
      return (name === 'title' || name === 'default') && values.length === 1 && normalize(values[0]).toLowerCase() === 'default title';
    }

    function ensureDrawer(){
      if(document.querySelector('[data-onlyoni-qa-panel]')) return;

      var backdrop = document.createElement('div');
      backdrop.className = 'onlyoni-qa-backdrop';
      backdrop.setAttribute('data-onlyoni-qa-close','');

      var panel = document.createElement('aside');
      panel.className = 'onlyoni-qa-panel';
      panel.setAttribute('data-onlyoni-qa-panel','');
      panel.setAttribute('aria-hidden','true');

      panel.innerHTML =
        '<div class="onlyoni-qa-header" data-onlyoni-qa-drag>' +
          '<h2 class="onlyoni-qa-title">Agregar al carrito</h2>' +
          '<button type="button" class="onlyoni-qa-close" data-onlyoni-qa-close aria-label="Cerrar">' +
            '<svg viewBox="0 0 24 24" fill="none"><path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="onlyoni-qa-body">' +
          '<div class="onlyoni-qa-product">' +
            '<onlyoni-qa-gallery></onlyoni-qa-gallery>' +
            '<div><h3 class="onlyoni-qa-product-name"></h3><div class="onlyoni-qa-price"></div></div>' +
          '</div>' +
          '<div class="onlyoni-qa-options"></div>' +
          '<div class="onlyoni-qa-quantity">' +
            '<span class="onlyoni-qa-label">Cantidad</span>' +
            '<div class="onlyoni-qa-quantity-box">' +
              '<button type="button" class="onlyoni-qa-qty-btn" data-onlyoni-qa-minus aria-label="Restar">−</button>' +
              '<span class="onlyoni-qa-qty-value">1</span>' +
              '<button type="button" class="onlyoni-qa-qty-btn" data-onlyoni-qa-plus aria-label="Sumar">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="onlyoni-qa-actions">' +
            '<button type="button" class="onlyoni-qa-add" data-onlyoni-qa-add>Agregar al carrito</button>' +
            '<a class="onlyoni-qa-view" data-onlyoni-qa-view href="#">Ver producto</a>' +
          '</div>' +
          '<div class="onlyoni-qa-status" role="status" aria-live="polite"></div>' +

          '<div class="onlyoni-qa-trust">' +
            '<div class="onlyoni-qa-trust-item"><span class="onlyoni-qa-trust-icon"><svg viewBox="0 0 24 24" fill="none"><path d="M4 7H20V17H4V7Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M7 11H11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></span><span><strong>Pago contra entrega</strong><small>Paga al recibir tu pedido</small></span></div>' +
            '<div class="onlyoni-qa-trust-item"><span class="onlyoni-qa-trust-icon"><svg viewBox="0 0 24 24" fill="none"><path d="M3 7H14V17H3V7Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M14 11H18L21 14V17H14V11Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="7" cy="18" r="2" stroke="currentColor" stroke-width="2"/><circle cx="17" cy="18" r="2" stroke="currentColor" stroke-width="2"/></svg></span><span><strong>Envíos a toda Guatemala</strong><small>Cobertura nacional con Forza</small></span></div>' +
            '<div class="onlyoni-qa-trust-item"><span class="onlyoni-qa-trust-icon"><svg viewBox="0 0 24 24" fill="none"><path d="M12 3L20 6V12C20 17 16.5 20.5 12 22C7.5 20.5 4 17 4 12V6L12 3Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M8.5 12L11 14.5L15.5 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span><strong>Compra segura</strong><small>Tus datos protegidos</small></span></div>' +
          '</div>' +
        '</div>';

      document.body.appendChild(backdrop);
      document.body.appendChild(panel);
      var sizeTemplate = document.querySelector('.oo-quick-size-template');
      if(sizeTemplate) panel.querySelector('.onlyoni-qa-product').after(sizeTemplate.content.cloneNode(true));
      panel.appendChild(panel.querySelector('.onlyoni-qa-actions'));

      var dragHandle = panel.querySelector('[data-onlyoni-qa-drag]');
      if(dragHandle){
        dragHandle.addEventListener('touchstart',function(event){
          state.startY = event.touches && event.touches[0] ? event.touches[0].clientY : null;
        },{passive:true});

        dragHandle.addEventListener('touchend',function(event){
          if(state.startY === null) return;
          var endY = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientY : state.startY;
          if(endY - state.startY > 55) closeDrawer();
          state.startY = null;
        },{passive:true});
      }
    }

    function closeDrawer(){
      document.body.classList.remove('onlyoni-qa-open');
      var panel = document.querySelector('[data-onlyoni-qa-panel]');
      if(panel) panel.setAttribute('aria-hidden','true');
    }

    function showSuccessToast(){
      var toast = document.querySelector('.onlyoni-qa-toast');

      if(!toast){
        toast = document.createElement('div');
        toast.className = 'onlyoni-qa-toast';
        toast.setAttribute('role','status');
        toast.setAttribute('aria-live','polite');
        toast.innerHTML =
          '<span class="onlyoni-qa-toast__icon" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" fill="none"><path d="M5 12.5L9.2 16.5L19 7" stroke="currentColor" stroke-width="2.7" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</span>' +
          '<span>' +
            '<strong class="onlyoni-qa-toast__text">Agregado al carrito</strong>' +
            '<small class="onlyoni-qa-toast__sub">Buena elección.</small>' +
          '</span>';

        document.body.appendChild(toast);
      }

      clearTimeout(window.onlyOniQuickAddToastTimer);
      requestAnimationFrame(function(){
        toast.classList.add('is-visible');
      });

      window.onlyOniQuickAddToastTimer = setTimeout(function(){
        toast.classList.remove('is-visible');
      }, 2600);
    }

    function getProductFromButton(button){
      var wrapper = button.closest('[data-onlyoni-collection-card]');
      var jsonNode = wrapper ? wrapper.querySelector('.onlyoni-card-product-json') : null;
      if(!jsonNode) return null;
      try { return JSON.parse(jsonNode.textContent); }
      catch(error){ console.error('Only Oni quick add: JSON inválido', error); return null; }
    }

    function openDrawer(product){
      ensureDrawer();

      state.product = product;
      state.quantity = 1;

      var firstAvailable = product.variants.find(function(variant){ return variant.available; }) || product.variants[0];
      state.selectedOptions = firstAvailable ? firstAvailable.options.slice() : [];
      state.variant = firstAvailable || null;

      renderDrawer();

      document.body.classList.add('onlyoni-qa-open');
      var panel = document.querySelector('[data-onlyoni-qa-panel]');
      if(panel) panel.setAttribute('aria-hidden','false');
    }

    function availableForValue(optionIndex,value){
      var product = state.product;
      if(!product) return false;

      return product.variants.some(function(variant){
        if(!variant.available) return false;

        return variant.options.every(function(optionValue,index){
          if(index === optionIndex) return optionValue === value;
          return !state.selectedOptions[index] || optionValue === state.selectedOptions[index];
        });
      });
    }

    function findSelectedVariant(){
      var product = state.product;
      if(!product) return null;

      return product.variants.find(function(variant){
        return variant.options.every(function(optionValue,index){
          return optionValue === state.selectedOptions[index];
        });
      }) || null;
    }

    function renderDrawer(){
      var product = state.product;
      var panel = document.querySelector('[data-onlyoni-qa-panel]');
      if(!product || !panel) return;

      state.variant = findSelectedVariant() || state.variant;

      var image = panel.querySelector('.onlyoni-qa-image');
      var title = panel.querySelector('.onlyoni-qa-product-name');
      var price = panel.querySelector('.onlyoni-qa-price');
      var options = panel.querySelector('.onlyoni-qa-options');
      var qtyValue = panel.querySelector('.onlyoni-qa-qty-value');
      var addButton = panel.querySelector('[data-onlyoni-qa-add]');
      var viewButton = panel.querySelector('[data-onlyoni-qa-view]');
      var status = panel.querySelector('.onlyoni-qa-status');
      var variantImage = state.variant && state.variant.featured_image ? state.variant.featured_image : product.featured_image;

      panel.querySelector('onlyoni-qa-gallery').update(product, variantImage);
      var sizeGuide = panel.querySelector('.oo-quick-size');
      if(sizeGuide) sizeGuide.hidden = !product.size_guide;
      if(title) title.textContent = product.title || '';
      if(price) price.textContent = state.variant ? money(state.variant.price) : money(product.price);
      if(qtyValue) qtyValue.textContent = String(state.quantity);
      if(viewButton) viewButton.href = product.url || '#';
      if(status) status.textContent = '';

      options.innerHTML = '';

      if(!isDefaultOnly(product)){
        product.options.forEach(function(option,optionIndex){
          if(!option || !option.values || !option.values.length) return;

          var group = document.createElement('div');
          group.className = 'onlyoni-qa-option';

          var label = document.createElement('span');
          label.className = 'onlyoni-qa-label';
          label.textContent = option.name;

          var values = document.createElement('div');
          values.className = 'onlyoni-qa-values';

          option.values.forEach(function(value){
            var choice = document.createElement('button');
            choice.type = 'button';
            choice.className = 'onlyoni-qa-choice';
            choice.textContent = value;
            choice.dataset.optionIndex = String(optionIndex);
            choice.dataset.optionValue = value;

            var isSelected = state.selectedOptions[optionIndex] === value;
            var isAvailable = availableForValue(optionIndex,value);

            if(isSelected) choice.classList.add('is-selected');
            if(!isAvailable){ choice.classList.add('is-disabled'); choice.disabled = true; }

            values.appendChild(choice);
          });

          group.appendChild(label);
          group.appendChild(values);
          options.appendChild(group);
        });
      }

      if(addButton){
        var valid = !!(state.variant && state.variant.available);
        addButton.disabled = !valid;
        addButton.textContent = valid ? 'Agregar al carrito' : 'Agotado';
      }
    }

    function updateCartCount(count){
      var bubbles = document.querySelectorAll('.cart-count-bubble');

      bubbles.forEach(function(bubble){
        bubble.classList.remove('hidden');
        var inner = bubble.querySelector('span:first-child');
        if(inner) inner.textContent = String(count);
        else bubble.textContent = String(count);
      });

      if(!bubbles.length){
        var cartIcon = document.querySelector('#cart-icon-bubble, a[href="/cart"], a[href*="/cart"]');
        if(cartIcon){
          var bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true">' + count + '</span>';
          cartIcon.appendChild(bubble);
        }
      }
    }

    function addToCart(){
      var panel = document.querySelector('[data-onlyoni-qa-panel]');
      if(!state.variant || !state.variant.available || !panel) return;

      var addButton = panel.querySelector('[data-onlyoni-qa-add]');
      var status = panel.querySelector('.onlyoni-qa-status');

      if(addButton){ addButton.disabled = true; addButton.textContent = 'Agregando...'; }

      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:state.variant.id,quantity:state.quantity})
      })
      .then(function(response){
        if(!response.ok) throw new Error('No se pudo agregar.');
        return response.json();
      })
      .then(function(){
        return fetch('/cart.js',{headers:{'Accept':'application/json'}});
      })
      .then(function(response){ return response.json(); })
      .then(function(cart){
        updateCartCount(cart.item_count || 0);
        if(status) status.textContent = 'Agregado al carrito ✓ Buena elección.';
        if(addButton) addButton.textContent = 'Agregado ✓';
        document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:cart}}));

        setTimeout(function(){
          closeDrawer();
          showSuccessToast();

          if(addButton){
            addButton.disabled = false;
            addButton.textContent = 'Agregar al carrito';
          }
        },650);
      })
      .catch(function(){
        if(status) status.textContent = 'No se pudo agregar. Intenta de nuevo.';
        if(addButton){ addButton.disabled = false; addButton.textContent = 'Agregar al carrito'; }
      });
    }

    document.addEventListener('click',function(event){
      var closeTarget = event.target.closest('[data-onlyoni-qa-close]');
      if(closeTarget){ event.preventDefault(); closeDrawer(); return; }

      var quickButton = event.target.closest('[data-onlyoni-collection-quick-add]');
      if(quickButton){
        event.preventDefault();
        event.stopPropagation();
        if(event.stopImmediatePropagation) event.stopImmediatePropagation();

        var product = getProductFromButton(quickButton);
        if(product) openDrawer(product);
        return false;
      }

      var choice = event.target.closest('.onlyoni-qa-choice');
      if(choice && !choice.disabled){
        var optionIndex = Number(choice.dataset.optionIndex);
        var optionValue = choice.dataset.optionValue;
        state.selectedOptions[optionIndex] = optionValue;
        state.variant = findSelectedVariant();
        renderDrawer();
        return;
      }

      if(event.target.closest('[data-onlyoni-qa-minus]')){
        state.quantity = Math.max(1,state.quantity - 1);
        renderDrawer();
        return;
      }

      if(event.target.closest('[data-onlyoni-qa-plus]')){
        state.quantity = Math.max(1,state.quantity + 1);
        renderDrawer();
        return;
      }

      if(event.target.closest('[data-onlyoni-qa-add]')){
        addToCart();
      }
    },true);

    document.addEventListener('keydown',function(event){
      if(event.key === 'Escape') closeDrawer();
    });
  })();
